import { render } from "./LegsPage.vue?vue&type=template&id=615b7c39&scoped=true"
import script from "./LegsPage.vue?vue&type=script&lang=js"
export * from "./LegsPage.vue?vue&type=script&lang=js"

import "./LegsPage.vue?vue&type=style&index=0&id=615b7c39&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-615b7c39"]])

export default __exports__